import React from 'react'
import { Input as AntDInput, Form } from 'antd'
import PropTypes from 'prop-types'

import { Label } from '~stories'

const { Item: AntDFormItem } = Form

const Input = ({
  className,
  disabled,
  id,
  isInline,
  label,
  maxLength,
  onBlur,
  onChange,
  onKeyDown,
  placeholder,
  value
}) => {
  const inputProps = {
    className,
    disabled,
    id,
    ...(maxLength && { maxLength }),
    ...(onBlur && { onBlur }),
    ...(onChange && { onChange }),
    ...(onKeyDown && { onKeyDown }),
    placeholder,
    value
  }

  return (
    <>
      {label && <Label
        isInline={isInline}
        value={label}
      />}
      <AntDFormItem>
        <AntDInput {...inputProps} />
      </AntDFormItem>
    </>
  )
}

Input.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isInline: PropTypes.bool,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

Input.defaultProps = {
  disabled: false,
  isInline: false,
  label: '',
  placeholder: '',
  value: ''
}

export default Input
